<sd-form-libelle
  [idField]="'textarea-' + uuidInput"
  [labelHidden]="labelHidden"
  [labelTitle]="labelTitle"
  [required]="required"
/>

<textarea
  [id]="'textarea-'+uuidInput"
  [ngClass]="classField"
  [formControl]="internalField"
  [name]="nameField"
  [placeholder]="placeholder"
  [required]="required"
  [readonly]="readonly"
  [rows]="rows"
  [attr.maxlength]="maxlength"
  (blur)="propagateTouched()"
></textarea>

<ng-content select="[sd-message]" />
